import { useState, useTransition } from "react";
import Fuse from "fuse.js";

const useFuzzySearchSelect = (
  initialData,
  fuseOptions,
  setSelectedDealerId
) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [isPending, startTransition] = useTransition({ timeoutMs: 3000 });

  const fuse = new Fuse(initialData, fuseOptions);

  const performSearch = (pattern) => {
    if (!pattern || pattern.trim() === "") {
      return initialData;
    } else {
      const result = fuse.search(pattern);
      // console.clear();
      // console.log(result, "result");
      return result.map(({ item }) => item);
    }
  };

  const handleInputChange = (value) => {
    startTransition(() => {
      setSearchTerm(value);
    });
  };

  const handleOptionSelect = (optionId, option) => {
    // const option = initialData.find((item) => item.dealer_info_id === optionId);
    // console.log(option,'option');
    option && setSelectedOption(option.key);
    setSelectedDealerId(optionId);
  };

  return {
    searchTerm,
    isPending,
    handleInputChange,
    handleOptionSelect,
    performSearch,
    selectedOption,
    setSearchTerm,
  };
};

export default useFuzzySearchSelect;
